module.exports = __webpack_public_path__ + "static/img/Zak-Butters.dda6cff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Zak-Butters.jpg
// module id = fLbj
// module chunks = 0